<modal-panel title="Filter KT COGS" (close)="close()">
  <div class="filter" [formGroup]="form">
    <div class="filter__fields" [class.two-col]="!isSmall">

      <mat-form-field>
        <mat-label>Trip Reference</mat-label>
        <input matInput formControlName="TripReference" placeholder="e.g. ABCDEF"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Vendor Name</mat-label>
        <input matInput formControlName="VendorName" placeholder="e.g. Marriott"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Product Type</mat-label>
        <input matInput formControlName="ProductTypeName" placeholder="e.g. Hotel"/>
      </mat-form-field>

    </div>
  </div>
  <ng-container modalPanelFooter>
    <button mat-button (click)="reset()">Reset</button>
    <button mat-raised-button color="primary" (click)="apply()">Apply</button>
  </ng-container>
</modal-panel>
